<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';

export default {
  name: 'NewAvContractDialog',
  components: {
    RbxDatePicker,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      baseFormData: {
        name: '',
        date: '',
      },
      formData: {},
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    /* istanbul ignore next */
    this.visible = false;
  },
  methods: {
    ...mapActions('avContractDetails', ['saveAvContract']),
    ...mapActions('avContractList', { fetchData: 'fetchAvContractList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.saveAvContract(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('AV-Vertrag erfolgreich erstellt!');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/avContract/${data.id}`);
            }
          }
          this.fetchData();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Fehler beim Erstellen des AV-Vertrages. Bitte versuche es erneut!');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
    onDateInput(newDate) {
      this.formData.date = newDate;
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neuer AV-Vertrag
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>
              <h4 class="avContract-detail-tab-title">Basisdaten</h4>
              <v-layout row wrap>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.name"
                    :error-messages="validationErrorMessages.name"
                    label="Bezeichnung des AV-Vertrags"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md8 py-0/>

                <v-flex xs12 md4 py-0>
                  <rbx-date-picker label="Datum" :value="formData.date" @input="onDateInput" />
                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; Neu
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Detail
              </v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
